export default {
  path: "/user/cpa/galerias",
  component: () => import("@/views/user/cpa/galerias/GaleriasLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "galerias-admin",
      component: () =>
        import("@/views/user/cpa/galerias/GaleriasListView.vue"),
    },
    {
      path: ":galleryId",
      name: "galerias-detalle",
      component: () => import("@/views/user/cpa/galerias/GaleriasEditView.vue"),
      props: true,
    },
  ],
};
